import HappyBoxImage from '@assets/icons/happy-box.svg';
import React from 'react';
import { Confetti, ConfettiType } from './confetti';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  confettiType?: ConfettiType;
  showConfetti?: boolean;
}

export const HappyBox: React.FC<Props> = ({
  confettiType,
  showConfetti = true,
}) => {
  const theme = useTheme();

  return (
    <View style={styles.imageContainer}>
      {showConfetti ? <Confetti type={confettiType} /> : null}
      <View style={styles.image}>
        <HappyBoxImage fill={theme.colors.primary} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  image: {
    marginTop: -24,
  },
  imageContainer: {
    alignItems: 'center',
    marginBottom: 24,
    marginTop: 36,
  },
});
